module.exports = __webpack_public_path__ + "static/04-rey@2x-8d33dc87f3783a87364b7ce2cf03876f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/04-rey@2x.jpg
// module id = 2515
// module chunks = 168707334958949